define(['backbone', 'models/admin/AccountManager'], function(Backbone, AccountManagerModel) {
  return Backbone.Collection.extend({
    model: AccountManagerModel,
  });
});
